'use strict'

import moment from 'moment'

export function dateFormatter(date) {
  return moment(date).format('DD/MM/YYYY')
}

export function changeInitialDate(date) {
  if (date) {
    this.disabledDatesEnd = null
    this.disabledDatesEnd = new Object()
    this.disabledDatesEnd.to = new Date(date)
  }
}

export function changeFinalDate(date) {
  if (date) {
    this.disabledDatesStart = null
    this.disabledDatesStart = new Object()
    this.disabledDatesStart.from = new Date(date)
  }
}

export function cnpjFormatter(cnpj) {
  return cnpj.toString().replace(/[^0-9a-zA-Z]+/g, '')
}